import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { Icon } from './Icon';

type Variant = 'primary' | 'outline' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: 'sm' | 'md';
  icon?: string;
  children?: ReactNode;
}

/** Nút có chữ. Mặc định `type="button"` (không vô tình submit form). */
export function Button({ variant = 'outline', size = 'md', icon, className, children, type = 'button', ...rest }: ButtonProps) {
  return (
    <button type={type} className={`ws-btn ws-btn-${variant} ws-btn-${size}${className ? ` ${className}` : ''}`} {...rest}>
      {icon && <Icon name={icon} size={size === 'sm' ? 14 : 16} />}
      {children}
    </button>
  );
}

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'children'> {
  /** Bắt buộc: nhãn cho trình đọc màn hình (và tooltip) — nút chỉ có biểu tượng. */
  label: string;
  icon: string;
  size?: number;
  active?: boolean;
  /** React 19: `ref` là prop thường — để đặt focus (ngăn kéo, trả focus khi đóng). */
  ref?: Ref<HTMLButtonElement>;
}

/** Nút chỉ có biểu tượng — luôn có `aria-label` (W1.6). */
export function IconButton({ label, icon, size = 18, active, className, type = 'button', title, ...rest }: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={title ?? label}
      className={`ws-icon-btn${active ? ' is-active' : ''}${className ? ` ${className}` : ''}`}
      {...rest}
    >
      <Icon name={icon} size={size} />
    </button>
  );
}
